import { axiosInstance } from "lib/Api"
import useSWR from "swr"

// An explicit {} body is required; with no body at all, axios sends no
// Content-Type header, so the Zod schema rejects is
const fetcher = (url: string) => axiosInstance.post(url, {}).then((res) => res.data)

interface ExperimentResolution {
  arm: string | null
}

export const useGetDigitalRecommendationAccept = (applicationId: string | null) => {
  const { data, error, isLoading } = useSWR<ExperimentResolution, Error>(
    applicationId
      ? `${process.env.ADMIN_API}/experiments/acceptRecommendation/resolve/${applicationId}`
      : null,
    fetcher,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  )

  return {
    recommendationAcceptActive: data ? data.arm === "enabled" : undefined,
    isLoading,
    isError: error,
  }
}
